///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ProjectListViewType } from './project-enums';
import { computed, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { GtthLocalStorageService } from '../shared/auth/localStorage.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable()
export class ProjectsViewStateService {
    readonly currentViewType: WritableSignal<ProjectListViewType> = signal(ProjectListViewType.TABLE);

    readonly innerFilter: WritableSignal<string> = signal('');
    readonly companyFilter: WritableSignal<string> = signal('');
    readonly searchFilter: Signal<string> = computed(() => this.innerFilter() || this.companyFilter());

    private readonly _innerFilterChanges$ = new Subject<void>();
    readonly innerFilterChanges$ = this._innerFilterChanges$.asObservable().pipe(debounceTime(500));

    constructor(private readonly localStorageService: GtthLocalStorageService) {
        this.restoreCurrentViewType();
    }

    public setInnerFilter(value: string | undefined): void {
        this.innerFilter.set(value ?? '');
        this._innerFilterChanges$.next();
    }

    public setCustomerFilter(value: string | undefined): void {
        this.companyFilter.set(value ?? '');
    }

    public setCurrentViewType(type: ProjectListViewType) {
        this.currentViewType.set(type);
        this.localStorageService.setProjectsViewType(type);
    }

    private restoreCurrentViewType() {
        const storedViewType = this.localStorageService.getProjectsViewType();
        if (storedViewType) {
            this.setCurrentViewType(storedViewType as ProjectListViewType);
        }
    }
}
